var $2a0298290de0a62c$exports = {};
function $2a0298290de0a62c$var$getConfig() {
    return Object.assign(DEFAULT_CONFIG, JSON.parse(localStorage.getItem('schedule')) || '{}');
}
$2a0298290de0a62c$var$getel('upload').addEventListener('click', async ()=>{
    const file = $2a0298290de0a62c$var$getel('cfg').files[0];
    if (!file) {
        alert('Please select a file');
        return;
    }
    const text = await file.text();
    let data;
    try {
        data = JSON.parse(text);
    } catch  {
        alert('Invalid file contents');
        return;
    }
    localStorage.setItem('schedule', text);
    broadcastConfigToExtension();
    $2a0298290de0a62c$var$populate();
    setTheme();
    alert('Settings imported.');
});
$2a0298290de0a62c$var$getel('cfg').addEventListener('change', ()=>{
    $2a0298290de0a62c$var$getel('upload').disabled = $2a0298290de0a62c$var$getel('cfg').files.length !== 1;
});
$2a0298290de0a62c$var$getel('include_period_name').addEventListener('change', ()=>{
    $2a0298290de0a62c$var$editPeriodExample();
});
function $2a0298290de0a62c$var$getel(id) {
    const selector = `#${id}`;
    return document.querySelector(selector);
}
function $2a0298290de0a62c$var$populate() {
    const initial = $2a0298290de0a62c$var$getConfig();
    $2a0298290de0a62c$var$getel('foreground_color').value = initial.foreground_color;
    $2a0298290de0a62c$var$getel('background_color').value = initial.background_color;
    $2a0298290de0a62c$var$getel('foreground_text_color').value = initial.foreground_text_color;
    $2a0298290de0a62c$var$getel('background_text_color').value = initial.background_text_color;
    $2a0298290de0a62c$var$getel('schedule_color_background').checked = initial.use_schedule_color;
    $2a0298290de0a62c$var$getel('default-page').value = initial.default_page || '/';
    $2a0298290de0a62c$var$getel('cfg_body').innerHTML = [
        {
            name: 'Early Bird',
            code: 'EarlyBird'
        },
        {
            name: 'Lunch 1',
            code: 'Lunch 1'
        },
        {
            name: 'Lunch 2',
            code: 'Lunch 2'
        },
        {
            name: 'Block 1',
            code: 'Block1'
        },
        {
            name: 'Block 2',
            code: 'Block2'
        },
        {
            name: 'Block 3',
            code: 'Block3'
        },
        {
            name: 'Block 4',
            code: 'Block4'
        },
        {
            name: 'Block 5',
            code: 'Block5'
        },
        {
            name: 'Block 6',
            code: 'Block6'
        },
        {
            name: 'Block 7',
            code: 'Block7'
        },
        {
            name: 'Block 8',
            code: 'Block8'
        }
    ].map((x)=>`<tr><td>${x.name}</td><td><input data-for="name" data-period="${x.code}" value="${initial.schedule[x.code]?.name || ''}"}></td><td><input type="url" data-for="url" data-period="${x.code}" value="${initial.schedule[x.code]?.url || ''}"}></td></tr>`).join('\n');
    $2a0298290de0a62c$var$getel('include_period_name').checked = initial.include_period_name || initial.include_period_name === undefined;
    $2a0298290de0a62c$var$editPeriodExample();
}
function $2a0298290de0a62c$var$editPeriodExample() {
    // Sometimes I just like to watch the world burn.
    $2a0298290de0a62c$var$getel('example_name').innerHTML = `<a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ">${$2a0298290de0a62c$var$getel('include_period_name').checked ? 'Block 1 - Custom Name' : 'Custom Name'}</a>`;
}
$2a0298290de0a62c$var$populate();
$2a0298290de0a62c$var$getel('save-schedule').addEventListener('click', ()=>{
    const schedule = {};
    for (const x of document.querySelectorAll('input[data-for=name]')){
        const period = x.getAttribute('data-period');
        if (!schedule[period]) schedule[period] = {};
        schedule[period].name = x.value || null;
    }
    for (const x of document.querySelectorAll('input[data-for=url]')){
        const period = x.getAttribute('data-period');
        if (!schedule[period]) schedule[period] = {};
        schedule[period].url = x.value || null;
    }
    const data = $2a0298290de0a62c$var$getConfig();
    data.schedule = schedule;
    data.include_period_name = $2a0298290de0a62c$var$getel('include_period_name').checked;
    localStorage.setItem('schedule', JSON.stringify(data));
    broadcastConfigToExtension();
    alert('Saved.');
});
$2a0298290de0a62c$var$getel('save-default').addEventListener('click', ()=>{
    const data = $2a0298290de0a62c$var$getConfig();
    data.default_page = $2a0298290de0a62c$var$getel('default-page').value;
    localStorage.setItem('schedule', JSON.stringify(data));
    broadcastConfigToExtension();
    alert('Saved.');
});
$2a0298290de0a62c$var$getel('save-colors').addEventListener('click', ()=>{
    const data = $2a0298290de0a62c$var$getConfig();
    data.foreground_color = $2a0298290de0a62c$var$getel('foreground_color').value;
    data.background_color = $2a0298290de0a62c$var$getel('background_color').value;
    data.foreground_text_color = $2a0298290de0a62c$var$getel('foreground_text_color').value;
    data.background_text_color = $2a0298290de0a62c$var$getel('background_text_color').value;
    data.use_schedule_color = $2a0298290de0a62c$var$getel('schedule_color_background').checked;
    localStorage.setItem('schedule', JSON.stringify(data));
    broadcastConfigToExtension();
    setTheme();
    alert('Saved.');
});
$2a0298290de0a62c$var$getel('download').addEventListener('click', ()=>{
    const blob = new Blob([
        localStorage.getItem('schedule')
    ], {
        type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ethsbell.json';
    a.click();
    URL.revokeObjectURL(url);
});
$2a0298290de0a62c$var$getel('reset-colors').addEventListener('click', ()=>{
    if (!confirm('Are you sure you want to reset?')) return;
    const data = $2a0298290de0a62c$var$getConfig();
    data.foreground_color = '#1a2741';
    data.background_color = '#c34614';
    data.foreground_text_color = '#ffffff';
    data.background_text_color = '#ffffff';
    data.use_schedule_color = true;
    localStorage.setItem('schedule', JSON.stringify(data));
    broadcastConfigToExtension();
    setTheme();
    $2a0298290de0a62c$var$populate();
});
$2a0298290de0a62c$var$getel('reset-schedule').addEventListener('click', ()=>{
    if (!confirm('Are you sure you want to reset?')) return;
    const data = $2a0298290de0a62c$var$getConfig();
    data.schedule = {};
    localStorage.setItem('schedule', JSON.stringify(data));
    broadcastConfigToExtension();
    $2a0298290de0a62c$var$populate();
});
$2a0298290de0a62c$var$getel('instructions_toggle').addEventListener('click', ()=>{
    $2a0298290de0a62c$var$getel('instructions').classList.toggle('show');
});


//# sourceMappingURL=config.ee058fcb.js.map
